<template>
<div id="app">
  <Main :theme1='theme'/>
  <SecMain />
  <PopUp />
</div>
</template>

<script>
import Main from './components/Main'
import SecMain from './components/SecMain'
import PopUp from './components/PopUp'

export default {
  components: {
    Main,
    SecMain,
    PopUp
  },
  data(){
    return{
      theme:'',
    }
  },
  created(){
      var url = document.referrer
      // var url = window.location.href
      console.log(url)
      var a = url.split('?')
      var b = a[1].split('&')
      console.log(b)
      var theme = null
      for(let i = 0; i<b.length; i++){
          let arr = b[i].split('=');
          if(arr[0].replace(/(^\s*)|(\s*$)/g,'')== 'theme'){
            theme=arr[1]
            // that.theme = arr[1]
          }
      }
      var themeList = ['newclassic','newgrey','newblack']
      if(theme && themeList.includes(theme)){
        document.getElementsByTagName('body')[0].className=theme
      }
  },
  mounted(){
     if(window.feMonitor){
      try{
        feMonitor.setConfig(
          {
            sampleRate: 0.3,
            isCollectPerformance: true,
            title: 'PCF10资金分析'
          }
        )
      }catch(e){}
    }
  },
}
</script>

<style lang="less">
@import './assets/style/index.less';
.newgrey{
  background: #181c21; 
}
.newblack{
  background: #ffffff;
}
body { 
  background: #000000; 
  #app {
    width: 1364px;
    margin: 0 auto;
    position: relative;
    font-family: SimSun;
  }
}
::-webkit-scrollbar {
    width: 12px;
    height: 12px;
}
	
::-webkit-scrollbar-button {
    width: 8px;
    height: 8px;
}
::-webkit-scrollbar-button, ::-webkit-scrollbar-track-piece {
    background-color: #26282e;
    cursor: pointer;
}
.newgrey::-webkit-scrollbar-button, .newgrey::-webkit-scrollbar-track-piece {
    background-color: #181c21;
}
.newblack::-webkit-scrollbar-button, .newblack::-webkit-scrollbar-track-piece {
    background-color: #f7f7fc;
}
::-webkit-scrollbar-corner {
    background: #26282e;
}
.newblack::-webkit-scrollbar-corner {
    background: #fff;
}
.newgrey::-webkit-scrollbar-corner {
    background: #181c21;
}
::-webkit-scrollbar-thumb {
    background: #35373e;
    border-radius: 4px;
    border: 2px solid #26282e;
}
.newgrey::-webkit-scrollbar-thumb {
    background: #393941;
    border-radius: 4px;
    border: none;
}
.newblack::-webkit-scrollbar-thumb {
    background: rgba(75, 75, 114, 0.4);
    border-radius: 4px;
    border: none;
}

::-webkit-scrollbar-button, ::-webkit-scrollbar-track-piece {
    background-color: #26282e;
    cursor: pointer;
}
.newblack::-webkit-scrollbar-button, .newblack::-webkit-scrollbar-track-piece {
    background-color: #f7f7fc;
    cursor: pointer;
}
.newgrey::-webkit-scrollbar-button, .newgrey::-webkit-scrollbar-track-piece {
    background-color: #181c21;
    cursor: pointer;
}
</style>
